<template>
  <div class="topHeader" :style="{backgroundColor: backgroundColor}">
    <div class="topHeader-left" :style="{color: textColor}" @click="goBack">
      <i class="iconfont" v-show="!!leftIcon" :class="leftIcon"></i>
      <span class="topHeader-left-text" v-show="!!leftText">{{leftText}}</span>
      <img class="topHeader-left-img" v-show="!!leftSrc" :src="leftSrc" />
    </div>
    <div class="topHeader-mid">
      <p :style="{color: textColor}">{{label}}</p>
    </div>
    <div class="topHeader-right" :style="{color: textColor}">
      <span
        class="topHeader-right-text"
        v-show="!!rightText"
        :style="{color: textColor}"
      >{{rightText}}</span>
      <i class="iconfont" :class="rightIcon"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    leftIcon: {
      type: String,
      default: ""
    },
    leftText: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    rightIcon: {
      type: String,
      default: ""
    },
    rightText: {
      type: String,
      default: ""
    },
    backgroundColor: {
      type: String,
      default: "#ffffff"
    },
    textColor: {
      type: String,
      default: "#212121"
    },
    leftSrc: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  filters: {
    filterImg: function(value) {
      return `require(${value})`;
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.topHeader {
  width: 100%;
  height: 2rem;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  .topHeader-left {
    width: auto;
    // min-width: 3rem;
    height: 2rem;
    display: flex;
    align-items: center;
    .topHeader-left-img {
      width: 0.8rem;
      height: 0.8rem;
    }
    .topHeader-left-text {
      width: auto;
      height: 2rem;
      line-height: 2rem;
      font-size: 0.8rem;
      white-space: nowrap;
      overflow: hidden;
      text-align: left;
    }
  }
  .topHeader-right {
    width: auto;
    // min-width: 3rem;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .topHeader-right-img {
      width: 1rem;
      height: 1rem;
    }
    .topHeader-right-text {
      width: auto;
      height: 2rem;
      line-height: 2rem;
      font-size: 0.8rem;
      white-space: nowrap;
      overflow: hidden;
      text-align: right;
    }
  }
  .topHeader-mid {
    width: 100%;
    height: 2rem;
    display: flex;
    align-items: center;
    p {
      width: 100%;
      height: 2rem;
      line-height: 2rem;
      font-size: 1rem;
      padding: 0 0.5rem;
      box-sizing: border-box;
      letter-spacing: 0.1rem;
      text-align: left;
    }
  }
}
</style>